import { findLongestCommonTokenSequence, tokenize } from 'lib/utils/helper/tokenMatcher';

const getSpanText = (data) => {
  if (typeof data !== 'object' || !data) return '';
  if (data.plainRow !== undefined) return data.plainRow.toLowerCase();

  return data.text.toLowerCase();
};

const getPossibleMatches = (searchData, searchText) => {
  const searchTextTokens = tokenize(searchText);
  if (!searchTextTokens.length) return [];
  const results = [];

  for (const [, groupData] of Object.entries(searchData)) {
    for (const [, data] of groupData.entries()) {
      const spanText = getSpanText(data);
      const spanTextTokens = tokenize(spanText);
      if (!spanTextTokens.length) continue;
      const longestSequence = findLongestCommonTokenSequence(spanTextTokens, searchTextTokens);
      if (!longestSequence.length) continue;
      const minLength = Math.min(spanTextTokens.length, searchTextTokens.length);
      const lengthRation = Math.max(spanTextTokens.length, searchTextTokens.length) / minLength;
      // Penalty for matches with very different length, as they are less likely to be relevant
      // Picked coefficients from https://github.com/nol13/fuzzball.js/blob/f53f956ce04dfdfdb469c69ed988d2009586b9cf/fuzzball.js#L342
      const lengthScale = lengthRation > 8 ? .6 : 1;
      const score = longestSequence.length / minLength * lengthScale * 100;
      results.push({
        score,
        data,
      });
    }
  }

  return results.sort((a, b) => b.score - a.score);
}

// MAIN
const getTextToHighlight = (searchData, searchText) => {
  try {
    const possibleMatches = getPossibleMatches(searchData, searchText);
    if (!possibleMatches.length) return [];
    const rowIds = [possibleMatches[0].data.rowId];

    for (let i = 1; i < possibleMatches.length; i++) {
      const match = possibleMatches[i];

      if (match.score === possibleMatches[0].score) {
        rowIds.push(match.data.rowId);
      } else {
        break;
      }
    }

    return rowIds;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return [];
  }
};

export { getTextToHighlight };
